<template>
  <div>
    <div
      class="newStyle flex"
      data-aos="zoom-in-up"
      data-aos-delay="50"
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
    >
      <div
        v-for="(item, index) in secondNavList"
        :key="item.id"
        :class="{ active: menuIndex === index }"
        @click="changeMenu(index)"
      >
        <img :src="item.logoUrl" alt="" />
        <p class="hover-06c">{{ item.name }}</p>
        <p class="color-ff6b00">新款</p>
      </div>
    </div>
    <div
      data-aos="zoom-in-up"
      data-aos-delay="50"
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
      class="color-f5f5f6 bgHeight"
    ></div>
    <div
      class="doorList"
      data-aos="zoom-in-up"
      data-aos-delay="50"
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
    >
      <div class="line" v-for="(item, index) in newStyle" :key="item.id">
        <div class="index2" v-if="index === 1">
          <videoControl :swiperData="swiperData" :caseShow="caseShow" :scrollData="secondNavList[menuIndex]" v-show="swiperData.length > 0"/>
        </div>
        <img :src="item.url" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import "swiper/dist/js/swiper";
import Swiper from "swiper";
import AOS from "aos";
import videoControl from "@/components/videoControl";
export default {
  props: ["secondNavList", "secondNavIndex", "newStyle", "startAnimate","caseShow"],
  data() {
    return {
      menuIndex: 0,
      swiper1: null,
      swiperData: [],
      swiperDataS: []
    };
  },
  components: {
    videoControl,
  },
  mounted() {},
  created() {
    this.menuIndex = this.secondNavIndex;
  },
  mounted(){
  },
  methods: {
    toPages() {
      window.location.href =
        "http://192.168.110.158:8080/pdm/#/index?productId=15935";
    },
    changeMenu(index) {
      // if(index === 3) return
      this.menuIndex = index;
      // console.log(this.secondNavList, this.menuIndex);
      this.$emit("changeMenuIndex", index);
      this.getVideoSwiper(this.secondNavList[this.menuIndex].id);
    },

    getVideoSwiper(id) {
      this.$axios
        .get(`/open/sale/webSiteResourceShare?productWindowId=${id}`)
        .then((res) => {
          if (res.data.code === 0) {
            this.swiperData = res.data.data.filter((item) => item.type.includes("VIDEO"));
            console.log(this.swiperData);
          }
        });
    },
  },
  watch: {
    startAnimate: {
      handler() {
        if (this.startAnimate) {
          AOS.init();
        }
      },
      immediate: true,
    },
    secondNavIndex() {
      this.menuIndex = this.secondNavIndex;
    },
    secondNavList(){
      if(this.secondNavList.length > 0){
        this.getVideoSwiper(this.secondNavList[this.menuIndex].id);
      }
    }
  },
};
</script>

<style lang="less" scoped>
.color-ff6b00 {
  color: #ff6b00;
}

.color-f5f5f6 {
  background-color: #f5f5f6;
}

.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}

.newStyle {
  width: 1080px;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;

  & > div {
    width: calc(1080px / 4);
    padding-bottom: 15px;
    cursor: pointer;

    img {
      width: 90px;
      height: auto;
    }
  }

  & > div:hover {
    .hover-06c {
      color: #06c;
    }
  }

  & > div.active {
    .hover-06c {
      color: #06c;
    }
  }

  & > div:last-child {
    margin: 0;
  }
}

.bgHeight {
  height: 50px;
}

.doorList {
  .line {
    width: 100%;
    margin: 0 auto;
    border-bottom: 7px solid #f5f5f6;
    .index2 {
      width: 100%;
      margin: 0 auto;
      margin-bottom: 15px;
      .porTrait{
        width: 740px;
        margin: 0 auto;
      }
    }
    img {
      width: 1006px;
      height: auto;
      min-height: 420px;
    }

    .option {
      color: #0071e3;
      margin-bottom: 15px;
      cursor: pointer;
      flex-direction: column;

      .understand {
        font-size: 16px;
      }

      .arrow {
        width: 20px;
        height: 20px;
        font-size: 18px;
        margin-top: 9px;
        transform: rotate(90deg);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/doorList.vue